
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11211",
                "data-name": "矩形 11211",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(121 458)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_251",
        "data-name": "蒙版组 251",
        "class": "cls-2",
        "transform": "translate(-121 -458)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "zuixiaohua",
            "class": "cls-3",
            "d": "M105.775,106.9H104.65a1.125,1.125,0,0,0-1.125,1.125V118.15a1.125,1.125,0,0,0,1.125,1.125h10.125a1.125,1.125,0,0,0,1.125-1.125v-1.125h-7.875a2.25,2.25,0,0,1-2.25-2.25Zm1.125-1.125v9a1.125,1.125,0,0,0,1.125,1.125h9v2.25a2.25,2.25,0,0,1-2.25,2.25H104.65a2.25,2.25,0,0,1-2.25-2.25V108.025a2.25,2.25,0,0,1,2.25-2.25Zm1.125-2.25a1.125,1.125,0,0,0-1.125,1.125v10.125a1.125,1.125,0,0,0,1.125,1.125H118.15a1.125,1.125,0,0,0,1.125-1.125V104.65a1.125,1.125,0,0,0-1.125-1.125Zm0-1.125H118.15a2.25,2.25,0,0,1,2.25,2.25v10.125a2.25,2.25,0,0,1-2.25,2.25H108.025a2.25,2.25,0,0,1-2.25-2.25V104.65A2.25,2.25,0,0,1,108.025,102.4Z",
            "transform": "translate(21.6 358.6)"
          }
        }
      ]
    }
  ]
})
    }
  